/* Add m_exportEmails,multi,fn_getRecord, remove beforeunload Sep 21, 2024 */
<template lang>
<div style="text-align:left;">
 <strong>Opportunity Team</strong>
    <div  style="overflow-x:scroll">
		<b-table id="opportunityTeamData" v-model="d_pageData" style="font-size: 12px; padding-right: 0px; padding-left: 0px; min-height:500px; 
		bordered  margin-left: 0px; margin-right: 0px; border-right: 0.1em solid #adb5bd;" sticky-header="700px" small responsive selectable select-mode="multi" head-variant="light" :fields="d_headers"
		:items="c_opportunityTeamData"  @row-selected="m_onRowSelected"	selected-variant="success">
        <template #cell(accountId)="data">
            <div>
				<div>
				<kt-select
						p_appEntKey="acct"
						id="accountId"
						:p_currentVal="data.item.account"
						:p_readOnly="p_mode=='view'"
						:p_enableCreate="false"
						@change="m_getAccount($event,data.index)">
				</kt-select>
				</div>
				<sup>
				<b-form-rating
				style="border:none;"
				v-if="data.item.account"
				id="rating"
				variant="warning" 
				:value="data.item.rating||0"
				size="sm"
				stars=5
				inline
				readonly
				:index="index"
				@change="m_handleRatingChange">
				</b-form-rating>
				</sup>
				<sup v-if="data.item.account">Risk factor:<b v-html="m_ratingRF(d_opportunityTeamData[data.index].rating)"></b></sup>
            </div>
        </template>
        <template #cell(contacts)='data'>
			<div>
				<kt-list
						p_appEntKey="extr"
						id="contacts"
						:p_currentVals="data.item.accountContacts"
						:p_readOnly="p_mode=='view'"
						:p_enableCreate="false"
						:p_enableAdd="true"
						:p_filterFirstKey="data.item.accountId"
						@change="m_getContacts($event,data.index)">
				</kt-list>
			</div>
        </template>	
		<template #cell(constructionScopes)="data">
			<div>
				<kt-list
						p_appEntKey="constructionscope"
						id="constructionscopes"
						:p_currentVals="data.item.accountConstructionScopes"
						:p_readOnly="p_mode=='view'"
						:p_enableCreate="false"
						:p_enableAdd="true"
						@change="m_getScopes($event,data.index)">
				</kt-list>
			</div>
        </template>	
        <template #cell(description)="data">
			<div>
				<b-form-textarea
					id="description"
					placeholder="Extra description"
					v-model="data.item.description"
					type="text">
				</b-form-textarea>
			</div>
        </template>
       <template #cell(contractValue)="data">
		<div>
			<b-input-group prepend="$" size="sm">
				<b-form-input
					id="contractValue"
					v-model="data.item.contractValue"
					:value="d_opportunityTeamData[data.index].contractValue?Number(d_opportunityTeamData[data.index].contractValue).toLocaleString():''"
					type="number"
					:formatter="m_numberFormat"
					>
				</b-form-input>
			</b-input-group>
		</div>
        </template>		
        <template #cell(status)="data">
		<div>
            <b-form-select
				id="status"
				v-model="data.item.status"
				:options="d_vendorStatuses"
				required>
            </b-form-select> 
		</div>
        </template>	
	</b-table>
	</div>
	<div>
		<b-row style="margin-right:-150px;">
		<b-col>
		<b-button class="btn-add btn-add-cl-item" variant="outline-primary" title="Add role" @click="m_handleAddClick">
			<fa-icon icon="plus"/>
          Add
		</b-button>
		<b-button class="btn-save"   variant="outline-secondary" title="Save" @click="m_saveRows">
			<fa-icon icon="save" />
         Save
		</b-button>
		<b-button class="btn-delete"   variant="outline-danger" title="Delete"  :disabled="!d_deleteEnabled" @click="m_handleRemoveClick">
			<fa-icon icon="trash-alt" />
         Delete
		</b-button>
		</b-col>
		<b-col>
		Totals:<b>{{c_totalRows}}</b></b-col>
		<b-col></b-col>
		<b-col></b-col>
		<b-col><pre style="font-size:1em;font-family:Avenir,Helvetica,Arial,sans-serif;">        Contract Value:<b>${{c_calculateTotalValue}}</b></pre></b-col>
		<b-col></b-col>
		</b-row>
	</div>
</div>
</template>
<script>
import {fn_getOpportunityTeam,fn_saveOpportunityTeam,fn_deleteRecord} from "@/utils/api.js";
import util,{fn_fmtMoney,kbdpAlert} from "@/utils/util.js";
import {ratingsRF,refData} from "@/utils/ref-data.js";
import KTList from "@/components/Ctrl/KT-List.vue";
import { eventBus } from "@/main";
import {fn_generateReport} from "@/utils/report.js";
export default {
  name: "opportunityTeam",
  components: {
		'kt-list': KTList
		},
  props: {
	p_opportunityId:String,
	p_opportunityName:String,
  },
  data() {
    return {
		d_currentPage:1,
		d_perPage:5,
		d_selectedRow:null,
		d_selectedRowId:null,
		d_testRating:2,
		d_opportunityTeamData: [
        {
			opportunityId:this.p_opportunityId,
			accountId: null,
			account:null,
			rating:null,
			contacts:[],
			accountContacts:[],
			constructionScopes:[],
			accountConstructionScopes:[],
			description:null,
			contractValue: null,
			status: null,
			tempId:Date.now(),
			removed:0,
        },
      ],
      d_headers: [
        {label: "Company Name",key: "accountId",thStyle:"border-right: 0.1em solid #adb5bd; width:250px;"},
        {label: "Contact Persons",key: "contacts",thStyle:"border-right: 0.1em solid #adb5bd;width:200px;"},
		{label: "Construction Scopes", key: "constructionScopes", thStyle:"border-right: 0.1em solid #adb5bd;width:200px;"},
		{label:"Description",key:"description", thStyle:"border-right: 0.1em solid #adb5bd;width:200px;"},
		{label: "Contract value", key: "contractValue", thStyle:"border-right: 0.1em solid #adb5bd;width:70px;"},
        {label: "Status",title: "Status", key: "status",thStyle:"border-right: 0.1em solid #adb5bd;width:200px;" },
      ],
	d_reportColumns: [
        {title: "Company Name",field: "accountName", visible:true},
		{title: "Contract Value", field: "contractValue",visible:true},
        {title: "Status",field: "status",visible:true},
		{title: "Description",field:"description",visible:true},
		{title: "Construction Scopes", field: "constructionScope",visible:true},
        {title: "Contact Person(s)",field: "contactName",visible:true},
        {title: "Email",field: "email",visible:true},
		{title: "Phone No.",field: "phoneNo",visible:true},
      ],
	d_reportData:[],
	d_teamStatuses:refData.teamStatuses,
	d_constructionScopes:[],
	d_selectedScopes:[],
	d_pageData:null,
	d_reportTitle:"Distribution List - "+this.p_opportunityName,
	d_reportClicked:null,
	d_deleteEnabled:false,
	d_selectedRows:[],
	};
	},
	created(){
	
	refData.constructionScopes.forEach(c=>{
		var scope={text:c.name,value:c.name};
		this.d_constructionScopes.push(scope);
	})
	
	this.d_vendorStatuses=refData.vendorStatuses.map(v=>{return v.name;});

	
	let params={opportunityId:this.p_opportunityId};
			fn_getOpportunityTeam(params)
			.then((resp) =>
			{
			if (!resp.error) 
				{
				if((resp.recordData||[]).length>0) 
					this.d_opportunityTeamData=resp.recordData;
				else this.m_handleAddClick;
				} 	
	
           });
	
	},
	mounted() {
	
	/*
	window.addEventListener('beforeunload', 
			function (e) {
				kbdpAlert.showErr("Exit page?");
				e.preventDefault();
				e.returnValue = '';
            }
        );
	*/
		
	
  },
  computed: {
    c_totalRows(){if(this.d_opportunityTeamData.length>0) return this.d_opportunityTeamData.filter(row=>(!row.removed||row.removed==0)).length;
					else return null;
	},
	c_opportunityTeamData(){
		if(this.d_opportunityTeamData.length>0) return this.d_opportunityTeamData.filter(row=>(!row.removed||row.removed==0));
		else return null;
	},
    c_calculatePageValue() {
	var total= 0;
	if(this.d_pageData?.length>0){
      for (let i = 0; i < this.d_pageData.length; i++) {
        if (this.d_pageData[i].contractValue&& (!this.d_pageData[i].removed||this.d_pageData[i].removed==0))
          total += parseFloat(this.d_pageData[i].contractValue);
				}
      } 
	return total.toLocaleString();
    },
    c_calculateTotalValue() {
	var total= 0.00;
	if(this.d_opportunityTeamData.length>0){
      
      for (let i = 0; i < this.d_opportunityTeamData.length; i++) {
        if (this.d_opportunityTeamData[i].contractValue&& (!this.d_opportunityTeamData[i].removed||this.d_opportunityTeamData[i].removed==0))
          total += parseFloat(this.d_opportunityTeamData[i].contractValue);
			}
      }
	return total?total.toLocaleString('en'):'0.00';
    },
  },
  methods: {
	m_ratingRF(rating){	rating=rating?rating:0;
						var riskFactor=ratingsRF.filter(r=>r.rating==rating)[0];
						return riskFactor.html;
						},
	m_chgPgSize(x){
		this.d_perPage=x;
	},
	m_onRowSelected(rows){if(rows.length>0){
						this.d_selectedRow={};
						var recordId;
						this.d_selectedRowId=null;
						if(rows.length==1){
							this.d_selectedRow=rows[0];
							recordId=this.d_selectedRow.opportunityTeamAccountId||this.d_selectedRow.tempId;
							this.d_selectedRowId=this.d_opportunityTeamData.findIndex(d=>(d.opportunityTeamAccountId||d.tempId)==recordId);
							}
						this.d_selectedRows=[...rows];
						this.d_deleteEnabled=true;
						} else{	this.d_selectedRows.length=0;
								this.d_deleteEnabled=false;
								}
	},
	m_numberFormat(value,e) {return value?value.toLocaleString('en'):""; },
	m_deleteRow(recId){
			let recordLabel = this.d_opportunityTeamData[recId].account.accountName;
			let temp = [...this.d_opportunityTeamData];
			temp.splice(recId, 1);
			this.d_opportunityTeamData = [...temp];
			this.d_deleteEnabled=false;
			kbdpAlert.showOk(recordLabel + " is Deleted Successfully.");
	
	},
	m_handleRatingChange(){},
	m_saveRows(e){
		this.d_reportClicked=true;
		console.log('In m_saveRows');
		console.log(this.d_opportunityTeamData);
		let contacts=[];
		let constructionScopes=[];
		let p_opportunityTeamData=this.d_opportunityTeamData.map(o=>{
						if(o.accountId)
							return {opportunityTeamAccountId:o.opportunityTeamAccountId,
									accountId:o.accountId,
									rating:o.rating,
									contacts:o.contacts,
									constructionScopes:o.constructionScopes,
									description:o.description,
									contractValue:o.contractValue,
									status:o.status
									};
				});
									
		var params={opportunityId:this.p_opportunityId,
					recordData:JSON.stringify(p_opportunityTeamData)
					};

	fn_saveData(this,params);
	},
    m_handleAddClick() {
      var temp = [...this.d_opportunityTeamData];
      temp.push({
		opportunityTeamAccountId:null,
		opportunityId:this.p_opportunityId,
		accountId:null,
		account:null,
        rating: null,
        contacts: [],
		accountContacts:[],
        constructionScopes: [],
		accountConstructionScopes:[],
		description:null,
        contractValue: null,
        status: null,
		removed:0,
		tempId:Date.now(),
      });
      this.d_opportunityTeamData = temp;
    },
    m_handleRemoveClick() {
	
			
				if(this.d_selectedRowId != null)
					fn_deleteRoutine(this,this.d_selectedRowId);
					/*
					let temp = [...this.d_opportunityTeamData];
					temp.splice(this.d_selectedRowId, 1);
					this.d_opportunityTeamData = [...temp];
					this.d_deleteEnabled=false;
					*/
			
		},
		m_getContacts(e,idx){
							this.d_opportunityTeamData[idx].accountContacts=e;
							this.d_opportunityTeamData[idx].contacts=e.map(c=>{return c.externalContactId;});
							},
		m_getScopes(e,idx){
							this.d_opportunityTeamData[idx].accountConstructionScopes=e;
							this.d_opportunityTeamData[idx].constructionScopes=e.map(s=>{return s.constructionScopeId;});
							},
		m_getAccount(e,idx){	
								if(e.accountId){
								this.d_opportunityTeamData[idx].account=e;
								this.d_opportunityTeamData[idx].accountId=e.accountId;
								this.d_opportunityTeamData[idx].rating=e.rating||0;
								}else{
									this.d_opportunityTeamData[idx].account=null;
									this.d_opportunityTeamData[idx].accountId=null;
									this.d_opportunityTeamData[idx].rating=null;
								}
								
							},
		m_generateReportData(){
								this.d_reportData.length=0;
								this.d_opportunityTeamData.forEach(r=>{
									var accountName=r.account.accountName;
									var contractValue=r.contractValue;
									var description=r.description;
									var status=r.status;
									var contactCount=r.accountContacts?r.accountContacts.length:0;
									var scopeCount=r.accountConstructionScopes?r.accountConstructionScopes?.length:0;
									var maxIdx=Math.max(contactCount,scopeCount,1);
									var contacts=r.accountContacts?[...r.accountContacts]:null;
									var constructionScopes=r.accountConstructionScopes?[...r.accountConstructionScopes]:null;
									for(var i=0; i<maxIdx; i++) {
													if(i>0) accountName=contractValue=description=status=null;
													var constructionScopeName=i<scopeCount?constructionScopes[i].constructionScopeName:null;
													var externalContactName=i<contactCount?contacts[i].externalContactName:null;
													var email=i<contactCount?contacts[i].email:null;
													var phoneNo=i<contactCount?contacts[i].phoneNo:null;
													
													this.d_reportData.push({accountName:accountName,
																			contractValue:contractValue,
																			status:status,
																			description:description,
																			constructionScope:constructionScopeName,
																			contactName:externalContactName,
																			email:email,
																			phoneNo:phoneNo});
																			
													}
									});
								console.log(this.d_reportData);
							},
		m_generatePdf(){
						this.m_generateReportData();
						var p_report={reportType:'pdf', title:'Distribution List', reportData:this.d_reportData,
						reportColumns:this.d_reportColumns.map(c=>c.field),allColumns:this.d_reportColumns};
						fn_generateReport(p_report);
					},
		m_generateExcel(){
						this.m_generateReportData();
						var p_report={reportType:'excel', title:'Distribution List', reportData:this.d_reportData,
						reportColumns:this.d_reportColumns.map(c=>c.field),allColumns:this.d_reportColumns};
						fn_generateReport(p_report);
						},
		m_exportEmails()
			{
				var emailAddresses=null;
				var email=null;
				var activeRows=this.d_selectedRows.length>0?this.d_selectedRows:this.d_opportunityTeamData;
				activeRows.forEach(r=>{
				var contacts=r.accountContacts?[...r.accountContacts]:null;
				for(var i=0; i<contacts.length; i++) {
					email=contacts[i].email;
					if(email) 
						emailAddresses=emailAddresses?emailAddresses+","+email:email;
					}
				});
				if(emailAddresses){
					var a = document.createElement('a');
					a.href='mailto:'+emailAddresses;
					a.target = '_blank';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}
		},
	},
  watch: {},
};
function fn_saveData(vc,params) {

	kbdpAlert.showSaving('opportunityTeam Data');
	console.log(params);
	fn_saveOpportunityTeam(params).then(resp => {
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to save opportunityTeam Data ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}
		kbdpAlert.showOk('opportunityTeam Data saved successfully');
	//Refresh data
	fn_getOpportunityTeam({opportunityId:vc.p_opportunityId})
	.then(resp => {
					vc.d_opportunityTeamData=resp.recordData;
				});
	})
}
function fn_deleteRoutine(vc,recId) {

	let recordLabel = vc.d_opportunityTeamData[recId].account.accountName;   
	let opportunityTeamAccountId = vc.d_opportunityTeamData[recId].opportunityTeamAccountId;
	let content = {
		titleText: 'Confirm Delete',
		message1:`Are you sure you want to delete the Account ${recordLabel}?`,

	};
	let cm = util.fn_getModal_confirm(vc, content);

	vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
		if (!resp) return;



		let appEntNm = 'opportunityTeam';
		if(opportunityTeamAccountId){
			kbdpAlert.showDeleting(`Opportunity Team Account ${recordLabel}`);
			fn_deleteRecord(appEntNm, opportunityTeamAccountId).then(resp => {
				if (resp.error || !resp.status) {
					kbdpAlert.showErr("Unable to delete record");
					return;
				}
				vc.m_deleteRow(recId);
			});
		} else vc.m_deleteRow(recId);
		});
}
</script>
<style scoped lang="scss">
.kt-table {
	.kt-table-table {
		font-size: 12.5px;
		overflow-x: auto;
		border-top: solid 0.1em #6c757d;

		&[style*="height"] {
			min-height: 150px;
		}
		&:not([style*="height"]) {
			min-height: calc(100vh - 280px);
			position: relative;
			> table.b-table {
				margin-bottom: 35px;
			}
			> .kt-table-aggr {
				position: absolute;
				bottom: 0;
			}
		}

		> div.loading-spiner,
		> div.error,
		> div.nodata {
			width: 100%;
			font-size: 1em;
			text-align: center;
			padding: 0.5em 0;
		}

		> table.b-table {
			border-bottom: solid 0.1em #dee2e6;
			margin-bottom: 1em;
			width: 100%;

			thead {
				background-color: #6c757d;
				color: #fff;
				th {
					padding: 0.2em 0.5em;
					vertical-align: middle;
					white-space: nowrap;
					font-weight: unset;

					position: relative;
					min-width: 60px;
					border-right: solid 0.1em #adb5bd;
					&.wrap {
						white-space: unset;
						min-width: 130px;
					}
					&.th-detail {
						width: 25px;
						min-width: unset;
						border-right: unset;
					}
					&:last-child {
						min-width: unset;
					}

					> span:first-child {
						&:hover {
							cursor: pointer;
							text-decoration: underline;
						}
					}
					> span:nth-child(2) {
						display: inline-block;
						text-align: right;
						width: 10px;
						&.asc::before {
							content: " ↑";
						}
						&.desc::before {
							content: " ↓";
						}
					}
					> span.resizer {
						position: absolute;
						top: 0em;
						bottom: 0em;
						right: -0.5em;
						width: 1em;
						z-index: 100;
						user-select: none;
						// border: solid 0.1em red;
						&:hover {
							cursor: ew-resize;
						}
					}

					&.resizing {
						border-right-color: #fff;
						> span.resizer {
							width: 20em;
							right: -10em;
							height: 20em;
						}
					}
				}
			}
			tbody {
				tr.detail-open td.detail svg {
					transform: rotate(90deg);
				}
				tr.detail-view {
					&:hover {
						background-color: unset;
					}
					td > div {
						display: flex;
						flex-wrap: wrap;

						border-left: solid 0.1em rgba(77, 163, 255, 0.3);
						padding-left: 0.5em;
						margin-left: 0.3em;
						margin-bottom: 1em;

						span {
							display: block;
							flex: 0 0 50%;
							@media (max-width: 576px) {
								flex: 0 0 100%;
							}
							padding: 0.3em 0.5em;

							&:hover {
								//background-color: #f8f9fa;
							}
						}
					}
				}
				tr {
					td span {
						word-break: break-all;
					}
					td.td-num-key {
						white-space: nowrap;
					}
					td.td-usr,
					td.td-dtm {
						font-size: 0.9em;
					}
					td span.btn {
						padding: 0;
						font-size: 1em;
						text-align: unset;
					}
				}
			}
		}
	}
	.kt-table-aggr {
		height: 25px;
		display: flex;
		flex-wrap: wrap;
		font-size: 1em;
		padding: 0.2em 0;

		// border: solid 0.1em red;
		> div {
			display: flex;
			flex-wrap: nowrap;
			// border: solid 0.1em blue;
			> div:nth-child(2) {
				margin: auto 0.5em;
				font-size: 0.95em;
				color: #adb5bd;
			}
		}
	}
}
label {
  font-weight: 600 !important;
}
*:focus {
  box-shadow: none !important;
  outline: none !important;
}

.input-group-text {
  height: 100% !important;
  border-radius: 0.375rem 0px 0px 0.375rem !important;
}
.b-icon.bi {
  color: #ffc107 !important;
}
.table td {
  border: none !important;
}

.small-td {
  width: 100px !important;
}
.large-td {
  width: 300px !important;
}

p {
  margin-left: 20px !important;
  color: #42b983 !important;
  font-weight: 600 !important;
}

.input-group {
  width: 150px !important;
}
.team-member-item {
  width: 150px !important;

  .multiselect {
    min-height: 38px !important;
    max-height: 100% !important;
    width: 150px !important;
.multiselect__tags {
      height: 30px !important;
      border-radius: 0px !important;
    }
  }
}
.person-fill {
  height: 43px;
}

.project-cost-heading {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.btn-save{
		color:#008000;
		borders:none;
		margin-left: 0.1em;;
		margin-right: 0.1em;
}
.tableHeader{
			background-color: #6c757d;
			color: #fff;
}
.form-control {
  margin-top: 0px !important;
}
.form-control:focus {
  box-shadow: none !important;
}
.svg-inline--fa.fa-w-14{width:0.5em !important;}
ta-end{text-align: end;}
b-table-sticky-header>.table.b-table>thead>tr>th {
 
    border-right: 0.1em solid #adb5bd;
	}
.selectOnTop{z-index: 0}
</style>
